import { LocationModel, LocationProvidersModel, LocationTrackingModel, OrganizationModel, PaymentGatewayConfiguration, ProviderModel } from "../../data/entities";
import { LocationODataRepo, LocationRepo } from "../../data/repo/organization";
import ServiceModel from "../../data/entities/booking/ServiceModel";
import { BaseEntityService } from "../BaseEntityService"

export class LocationService extends BaseEntityService<LocationModel, LocationRepo, LocationODataRepo> {
  constructor(){
    super(new LocationRepo(), new LocationODataRepo());
  }

  async getProviderLocationsByUserIdAsync(userId: number): Promise<LocationModel[]> {
      return await this.repo.getProviderLocationsByUserIdAsync(userId);
    }

  async getLocationsByRoleAccess(userId: number): Promise<LocationProvidersModel[] | null> {
    return await this.repo.getLocationsByRoleAccess(userId)
  }

  async getServices(locationId: number) : Promise<ServiceModel[]> {
    const services = await this.repo.getServices(locationId);
    return services || [];
  }

  async getProviderServices(locationId: number): Promise<ServiceModel[]> {
    const services = await this.repo.getProviderServices(locationId);
    return services || [];
  }

  async getTrackingAsync(locationCode: string): Promise<LocationTrackingModel | null> {
    return await this.repo.getTrackingAsync(locationCode);
  }

  async getWithAddressAndRegion(locationCode: string): Promise<LocationModel | null> {
    const location = await this.repo.getWithAddressAndRegion(locationCode);
    return location;
  }

  async getByLocationCodeAsync(locationCode: string): Promise<LocationModel | null> {
    const location = await this.repo.getByLocationCodeAsync(locationCode);
    return location;
  }

  async getProvidersByLocationCode(locationCode: string): Promise<ProviderModel[] | null> {
    const providers = await this.repo.getProvidersByLocationCode(locationCode);
    return providers;
  }
  async getPaymentOptionsAsync(id: number): Promise<any | null> {
    const paymentOptions = await this.repo.getPaymentOptionsAsync(id);
    return paymentOptions;
  }
  
  async getPublicPaymentOptionsAsync(id: number): Promise<PaymentGatewayConfiguration | null> {
    const paymentOptions = await this.repo.getPublicPaymentOptionsAsync(id);
    return paymentOptions;
  }

  async addPaymentOptionsAsync(id: number, paymentOptions: PaymentGatewayConfiguration): Promise<PaymentGatewayConfiguration | null> {
    const locationPaymentOption = await this.repo.addPaymentOptionsAsync(id, paymentOptions);
    return locationPaymentOption;
  }
}

export default LocationService;
